<div class="wishes-root">
  <div class="dialog-header">
    <div class="header-content">
      <mat-icon class="header-icon">restaurant</mat-icon>
      <div class="header-text">
        <div class="header-title">Forplejningsønsker</div>
        <div class="header-subtitle">{{ headerEventName }}</div>
      </div>
    </div>
    <div class="header-meta">
      @if (headerStartDate) {
        <span class="meta-badge">
          <mat-icon>event</mat-icon>
          {{ headerDateTimeRange }}
        </span>
      }
      @if (headerLocation) {
        <span class="meta-badge">
          <mat-icon>place</mat-icon>
          {{ headerLocation }}
        </span>
      }
      <span class="meta-badge meta-badge-count" matTooltip="Antal der tæller med i forplejning (uden afbud, venteliste og ikke-deltager)">
        <mat-icon>people</mat-icon>
        {{ totalParticipants }} til forplejning
      </span>
    </div>
    @if (showCloseButton) {
      <button mat-icon-button (click)="close()" class="close-btn" matTooltip="Luk">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <div class="wishes-content">
    @if (loading) {
      <div class="state-message">
        <mat-icon>hourglass_top</mat-icon>
        <span>Henter forplejningsønsker...</span>
      </div>
    } @else if (errorMessage) {
      <div class="state-message state-error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>
    } @else {
      <div class="summary-section">
        <div class="section-label">
          <mat-icon>summarize</mat-icon>
          Opsummering
        </div>
        @if (summaryKeys.length) {
          <div class="summary-chips">
            @for (key of summaryKeys; track key) {
              <div class="summary-chip">
                <span class="chip-count">{{ summaryCount(key) }}</span>
                <span class="chip-label">{{ preferenceComboSummaryLabel(key) }}</span>
              </div>
            }
          </div>
        } @else {
          <div class="empty-state">
            <mat-icon>info_outline</mat-icon>
            <span>Ingen registrerede forplejningsønsker endnu.</span>
          </div>
        }
      </div>

      @if (canShowEventCateringExtras) {
        <div class="extras-section">
          <div class="section-label">
            <mat-icon>add_shopping_cart</mat-icon>
            Forplejningskatalog
          </div>
          <p class="extras-hint">
            Vælg varer fra forplejningskataloget for dette event. Antallet beregnes som deltagere der tæller med i forplejning (uden afbud, venteliste og ikke-deltager) plus en valgfri justering (fx +2 eller -2).
          </p>
          @if (eventExtrasDisplayLines.length) {
            <div class="summary-chips extras-chips">
              @for (line of eventExtrasDisplayLines; track $index) {
                <div class="summary-chip" [class.inactive-extra]="line.is_active === false">
                  <span class="chip-count">{{ line.quantity }}</span>
                  <span class="chip-label">
                    {{ line.label }}
                    @if (line.comment) {
                      <span class="chip-comment"> — {{ line.comment }}</span>
                    }
                  </span>
                  @if (line.is_active === false) {
                    <span class="chip-inactive-tag">inaktiv</span>
                  }
                </div>
              }
            </div>
          } @else {
            <div class="empty-state extras-empty">
              <mat-icon>inventory_2</mat-icon>
              <span>Ingen varer registreret for dette event endnu.</span>
            </div>
          }

          <div class="extras-editor">
            @for (row of eventExtraLinesDraft; track row.line_id; let i = $index) {
              <div class="extras-row-block" [class.extras-row-block--locked]="row.locked">
                <div class="extras-row" [class.extras-row--locked]="row.locked">
                  <mat-form-field appearance="outline" class="extras-select-field">
                    <mat-label>Vare</mat-label>
                    <mat-select
                      [(ngModel)]="row.extra_option_id"
                      (ngModelChange)="onEventExtraDraftChange()"
                      [disabled]="!!row.locked">
                      <mat-option [value]="null">— Vælg —</mat-option>
                      @for (opt of activeExtraOptions; track opt.id) {
                        <mat-option [value]="opt.id">{{ opt.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="extras-pending-field extras-pending-field--readonly">
                    <mat-label>Til forplejning</mat-label>
                    <input
                      matInput
                      [value]="pendingParticipantCount"
                      readonly
                      tabindex="-1"
                      aria-readonly="true">
                    <mat-icon matSuffix class="extras-readonly-icon" matTooltip="Automatisk antal deltagere der tæller med i forplejning">lock</mat-icon>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="extras-qty-field">
                    <mat-label>Justering</mat-label>
                    <input
                      matInput
                      type="number"
                      [(ngModel)]="row.quantity_adjustment"
                      (ngModelChange)="onEventExtraDraftChange()"
                      placeholder="0">
                  </mat-form-field>
                  @if (row.locked) {
                    <mat-icon class="extras-lock-icon" matTooltip="Fastlåst vare fra forplejningskataloget">lock</mat-icon>
                  }
                  <button
                    mat-icon-button
                    type="button"
                    class="extras-remove-btn"
                    (click)="removeEventExtraRow(i)"
                    [disabled]="!!row.locked || eventExtraLinesDraft.length <= 1"
                    matTooltip="Fjern linje">
                    <mat-icon>remove_circle_outline</mat-icon>
                  </button>
                  @if (row.extra_option_id && !showExtraCommentField(row, i)) {
                    <button
                      mat-icon-button
                      type="button"
                      class="extras-comment-toggle-btn"
                      (click)="expandExtraComment(row, i)"
                      matTooltip="Tilføj kommentar til vare">
                      <mat-icon>comment</mat-icon>
                    </button>
                  }
                </div>
                @if (row.extra_option_id && showExtraCommentField(row, i)) {
                  <div class="extras-comment-row">
                    <mat-form-field appearance="outline" class="extras-comment-field" subscriptSizing="dynamic">
                      <mat-label>Kommentar (valgfri)</mat-label>
                      <input
                        matInput
                        [(ngModel)]="row.comment"
                        (ngModelChange)="onEventExtraDraftChange()"
                        (blur)="onExtraCommentBlur(row, i)"
                        placeholder="Fx særlige ønsker til denne vare…">
                    </mat-form-field>
                    @if (!(row.comment ?? '').trim()) {
                      <button
                        mat-icon-button
                        type="button"
                        class="extras-comment-collapse-btn"
                        (click)="collapseExtraComment(row, i)"
                        matTooltip="Skjul kommentarfelt">
                        <mat-icon>expand_less</mat-icon>
                      </button>
                    }
                  </div>
                }
              </div>
            }
            <div class="extras-actions">
              <button mat-stroked-button type="button" (click)="addEventExtraRow()">
                <mat-icon>add</mat-icon>
                Tilføj linje
              </button>
              @if (eventExtrasSaveStatus === 'saving') {
                <span class="extras-save-status extras-save-status--saving">Gemmer…</span>
              } @else if (eventExtrasSaveStatus === 'saved') {
                <span class="extras-save-status extras-save-status--saved">Gemt</span>
              }
            </div>
            @if (eventExtrasError) {
              <div class="extras-error">{{ eventExtrasError }}</div>
            }
          </div>
        </div>
      }

      @if (groupFeatureAvailable) {
        <div class="group-section">
          <div class="section-label">
            <mat-icon>groups</mat-icon>
            Forplejningsgrupper
          </div>
          <div class="group-row">
            <mat-form-field appearance="outline" class="group-select-field">
              <mat-label>Vælg forplejningsgrupper for eventet</mat-label>
              <mat-select
                multiple
                [(ngModel)]="selectedGroupIds"
                (ngModelChange)="onCateringGroupsChange()"
                [disabled]="loadingGroups || savingGroups">
                @for (group of availableGroups; track group.catering_group_id) {
                  <mat-option [value]="group.catering_group_id">{{ groupLabel(group) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (groupsSaveStatus === 'saving') {
              <span class="extras-save-status extras-save-status--saving">Gemmer…</span>
            } @else if (groupsSaveStatus === 'saved') {
              <span class="extras-save-status extras-save-status--saved">Gemt</span>
            }
          </div>
          @if (groupErrorMessage) {
            <div class="group-error">{{ groupErrorMessage }}</div>
          }
        </div>
      }

      @if (canShowEventCateringExtras) {
        <div class="order-comment-section">
          <mat-form-field appearance="outline" class="catering-room-field">
            <mat-label>Lokale for forplejning</mat-label>
            <mat-select
              [(ngModel)]="cateringRoomGuidDraft"
              [compareWith]="compareCateringRoomValue"
              (ngModelChange)="eventExtrasError = null">
              @for (opt of cateringRoomOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="order-comment-field">
            <mat-label>Kommentar til forplejningsordren (valgfri)</mat-label>
            <textarea
              matInput
              rows="2"
              [(ngModel)]="cateringOrderCommentDraft"
              (ngModelChange)="eventExtrasError = null"
              placeholder="Fx leveringstidspunkt, særlige ønsker til hele ordren…"></textarea>
          </mat-form-field>
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="saveEventCateringExtras()"
            [disabled]="savingEventExtras || !hasCateringOrderSettingsChanges">
            {{ savingEventExtras ? 'Gemmer...' : 'Gem indstillinger' }}
          </button>
          @if (eventExtrasError) {
            <div class="extras-error">{{ eventExtrasError }}</div>
          }
        </div>
      }

      <mat-divider></mat-divider>

      <div class="filter-bar">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Søg deltager</mat-label>
          <input matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()" placeholder="Navn eller email…">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="pref-filter-field">
          <mat-label>Filtrer på præference</mat-label>
          <mat-select [(ngModel)]="selectedPreferenceFilter" (ngModelChange)="applyFilter()">
            <mat-option value="">Alle præferencer</mat-option>
            @for (pref of allPreferences; track pref) {
              <mat-option [value]="pref">{{ pref }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (isFiltered()) {
          <button mat-stroked-button (click)="clearFilters()" class="clear-filter-btn"
                  matTooltip="Ryd alle filtre">
            <mat-icon>filter_alt_off</mat-icon>
            Ryd filter
          </button>
        }

        <div class="participant-count" [class.filtered]="isFiltered()">
          <mat-icon>group</mat-icon>
          @if (isFiltered()) {
            {{ filteredCount }} af {{ totalParticipants }}
          } @else {
            {{ totalParticipants }}
          }
          &nbsp;til forplejning
        </div>
      </div>

      <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort class="participants-table">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Navn</th>
            <td mat-cell *matCellDef="let item">
              <div class="name-cell">
                <div class="avatar">{{ item.name?.charAt(0)?.toUpperCase() || '?' }}</div>
                <span class="name-text">{{ item.name }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let item">
              @if (item.email) {
                <a [href]="'mailto:' + item.email" class="email-link" [matTooltip]="item.email">{{ item.email }}</a>
              } @else {
                <span class="empty-value">–</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Rolle</th>
            <td mat-cell *matCellDef="let item">
              @if (item.role) {
                <span class="role-badge">{{ roleLabel(item.role) }}</span>
              } @else {
                <span class="empty-value">–</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let item">
              @if (item.status) {
                <span class="status-badge">{{ statusLabel(item.status) }}</span>
              } @else {
                <span class="empty-value">–</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="preferences">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Forplejningsønsker</th>
            <td mat-cell *matCellDef="let item">
              <div class="pref-editor">
                <mat-form-field appearance="outline" class="pref-edit-field">
                  <mat-select
                    multiple
                    [ngModel]="getParticipantPreferences(item)"
                    (ngModelChange)="onParticipantPreferencesChange(item, $event)">
                    @for (option of preferenceOptions; track option.value) {
                      <mat-option [value]="option.value">{{ option.label }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <button
                  mat-stroked-button
                  color="primary"
                  [disabled]="!hasParticipantChanges(item) || isSavingParticipant(item)"
                  (click)="saveParticipantPreferences(item)">
                  {{ isSavingParticipant(item) ? 'Gemmer...' : 'Gem' }}
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="data-row"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
              <mat-icon>search_off</mat-icon>
              <span>Ingen deltagere matcher den valgte søgning/filter.</span>
            </td>
          </tr>
        </table>
      </div>

      <div class="actions">
        <button mat-stroked-button color="primary" (click)="exportPdf()" class="pdf-btn">
          <mat-icon>picture_as_pdf</mat-icon>
          Eksporter PDF
        </button>
        @if (showCloseButton) {
          <button mat-button (click)="close()">
            <mat-icon>close</mat-icon>
            Luk
          </button>
        }
      </div>
    }
  </div>
</div>
